import Layout2 from '@/layout/Layout2'

export default [{
  path: '/ap',
  component: Layout2,
  meta: { requiresAuth: true },
  children: [{
    path: 'timetables/morning',
    component: () => import('@/components/timetables/Morning')
  },{
    path: 'timetables/evening',
    component: () => import('@/components/timetables/Evening')
  }, {
    path: 'timetables/create',
    component: () => import('@/components/timetables/CreateTimetable')
  }, {
    path: 'timetables/edit/:id',
    component: () => import('@/components/timetables/EditTimetable'),
    props: true
  }]
}]
